import {
  CargoFilterEnum
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';

export function cargoOptions(): SelectOption<string>[] {
  return [
    CargoFilterEnum.FCL,
    CargoFilterEnum.LCL,
    CargoFilterEnum.AIR
  ].map((val: CargoFilterEnum) => {
    return { value: val, label: val };
  });
}
